import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
   private apiUrl = `${environment.apiUrl}/api/udaan/get-banners`;

  constructor(private http: HttpClient) {}

  getActiveBanners(date: string, isActive: boolean): Observable<any[]> {
    const params = new HttpParams()
      .set('date', date)
      .set('isActive', isActive.toString());

    return this.http.get<any[]>(this.apiUrl, { params });
  }
}
